import { Card as MagneticCard, CardProps } from "@magnetic/card";

interface Props extends CardProps {}

export const Card = (props: Props) => {
  return <MagneticCard {...props} />;
};
